<ng-container *transloco="let t">


    <h3 *ngIf="!is_live">{{ t('Setup your OK Alone Plan') }}</h3>
    <h3  *ngIf="is_live">{{ t('Update your OK Alone Plan') }}</h3>
  
    <ng-container *ngIf="plan">
  
    <div class="row">



            <div class="col-md-6 col-sm-6">

                @if (hide_contract_form == true || (plan.workers>20 && !updated_plan)) {
                    <p>{{ t('To change your plan please email us on') }} <a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.</p>
                }
                @else {

                    <b>Change how many people would you'd like to protect?</b>
    
                    <div class="row text-center mt-2">

                        <div class="col-xs-12">
                            <div class="selectcontainer">
                                <input type="number" [min]="form_min_workers" class="form-control" [(ngModel)]="pricing.workers" (change)="workers_changed()" style="max-width: 150px; font-size: 18px; text-align: center; margin: 0 auto;">
                            </div>
                            <div class="alert alert-info mt-2" *ngIf="showMinWorkersError">
                                Please email <a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a> to reduce your plan.
                            </div>
                            <div class="alert alert-info mt-2" *ngIf="showMaxWorkersError">
                                Please contact your sales representative or email <a href="mailto:sales@ok-alone.com" target="_new">sales&#64;ok-alone.com</a> to change your plan.
                            </div>
                            <div class="alert alert-info mt-2" *ngIf="showSalesContact">
                                <p *ngIf="!is_live">
                                    To choose 20+ workers please confirm here and a member of our sales team will reach out to you.
                                    Please email <a href="mailto:sales@ok-alone.com" target="_new">sales&#64;ok-alone.com</a> to find out more information.
                                </p>
                                <p *ngIf="is_live">
                                    Please reach out to your account manager at <a href="mailto:sales@ok-alone.com" target="_new">sales&#64;ok-alone.com</a>.
                                </p>
                                <p *ngIf="pendingSalesWorkers">
                                    Requested workers: <b>{{ pendingSalesWorkers }}</b>
                                </p>
                                <button type="button" class="btn btn-info text-white btn-sm" (click)="confirmSalesContact()" [disabled]="salesContactSending || salesContactSent">
                                    <span *ngIf="!salesContactSending && !salesContactSent">Confirm</span>
                                    <span *ngIf="salesContactSending"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></span>
                                    <span *ngIf="salesContactSent">Request sent</span>
                                </button>
                            </div>
                        </div>                              
                    </div>
                    <div class="form-group text-center">
                        <br/>
                        <form (ngSubmit)="submit()"  #contactForm="ngForm">
                        <button type="submit" class="btn btn-info signup-button text-white" name="signup-button"  [disabled]="loading || plan.workers==pricing.workers || showMinWorkersError || showMaxWorkersError || showSalesContact">        
                            <span *ngIf="!loading"><i class="fa fa-check"></i> Calculate a new Plan</span>
                            <span *ngIf="loading">Please Wait <i class="fa fa-spinner fa-spin" aria-hidden="true"></i></span>    
                        </button> 
                        <br/><br/>
                        <p><i class="fa fa-info-circle" aria-hidden="true"></i> Need more than 20 workers? Please email your OK Alone rep or <a href="mailto:sales@ok-alone.com" target="_new">sales&#64;ok-alone.com</a> to discuss your options.</p>   
                        </form>
                        <button type="submit" class="btn btn-secondary signup-button text-white" (click)="getContract()" [disabled]="loading" *ngIf="updated_plan">        
                            <span *ngIf="!loading"><i class="fa-solid fa-arrows-rotate"></i> Reset my Plan</span>
                            <span *ngIf="loading">Please Wait <i class="fa fa-spinner fa-spin" aria-hidden="true"></i></span>    
                        </button> 
                    </div>   

               

                    @if (hasPlanChangeOptions()) {
                   
                    <hr/>
                    <ul class="list-group">

                    <li class="list-group-item list-group-item-secondary text-center m-1 p-1">
                        <b>Change your Plan?</b>
                        <p>We have some other plans available:</p>
                    </li>

                    
                    <li class="list-group-item text-left" *ngIf="showMonitoringPlanOption()">
                
                        <h3 class="plan-title">Safety Monitoring Center <span class="recommended">(Recommended)</span></h3>
        
                            <p><b>Get Immediate 24/7 Emergency Help, Faster Than 911.</b></p>
                            <p><a href="https://www.okaloneworker.com/safety-monitoring-centre/" target="_new">Learn more about the Safety Monitoring Center and our Enhanced 24/7 Monitoring</a></p>

                            <button type="submit" class="btn btn-info text-white" name="signup-button"  [disabled]="loading" (click)="chooseMonitoring()">        
                                <span *ngIf="!loading"><i class="fa fa-check"></i> I need the 24/7 Emergency Response from the Safety Monitoring Center!</span>
                                <span *ngIf="loading">Please Wait <i class="fa fa-spinner fa-spin" aria-hidden="true"></i></span>    
                            </button>    
                    </li>

                    @if (showAutomatedPlanOption()) {

                        <li class="list-group-item text-left">
        
                            <h3 class="plan-title">Automated Monitoring<span class="recommended" *ngIf="plan.country != 'CA' && plan.country != 'US'">(Recommended)</span></h3>
                            <p><b>Automate your worker safety with OK Alone.</b></p>
                            <p><a href="https://www.okaloneworker.com/pricing/our-plans/" target="_new">Learn more about Automated Monitoring</a></p>

                            <button type="submit" class="btn btn-light signup-button2" name="signup-button"  [disabled]="loading" (click)="chooseAutomated()">        
                                <span *ngIf="!loading">
                                    <span *ngIf="plan.type == 'monitoring'"> Downgrade to Automated Monitoring Plan</span>
                                    <span *ngIf="plan.type == 'essentials'"> Upgrade to Automated Monitoring Plan</span>
                                </span>
                            </button>  
                            <p *ngIf="plan.type == 'monitoring'" class="downgrade-note"><b>Note:</b> By downgrading you will lose access to our Safety Monitoring Center.</p> 
                                
                        </li>

                    }

                    @if (showEssentialsPlanOption()) {
                        <li class="list-group-item text-left">
        
                            <h3 class="plan-title">Lone Worker Essentials Plan</h3>
                            <p><b>Essentials to locate and monitor your at-risk workers using your in-house team.</b></p>
                            <p><a href="https://www.okaloneworker.com/pricing/our-plans/" target="_new">Learn more about Lone Worker Essentials</a></p>

                            <button type="submit" class="btn btn-light signup-button2" name="signup-button" (click)="chooseEssentials()">        
                                Downgrade to Lone Worker Essentials
                            </button>   
                            <p class="downgrade-note"><b>Note:</b> By downgrading you will lose access to our Safety Monitoring Center.</p> 
                                
                        </li>
                    }
                    </ul>
                }
                }

            </div>
            <div class="col-md-6 col-sm-6" *ngIf="plan">

                @if (hide_contract_form == true || (plan.workers > 20 && !is_live && !updated_plan)) {
   
                }
                @else {

                <p class="larger-text text-center" *ngIf="!updated_plan" style="font-size: 20px;">Here's your Current Plan</p>
                <p class="larger-text text-center" *ngIf="updated_plan" style="font-size: 20px;">Here's what your Plan would be:</p>
                
                <ul class="list-group text-center">
                    <li class="list-group-item">
                      <h2><i class="fa fa-users fa-1x"></i><b> Your Plan is for {{plan.workers}} Lone Workers</b></h2>
                      
                    </li>
      
                    <li *ngIf="plan.type == 'monitoring'" class="list-group-item">
                        <span style="font-size: 16px;">You have chosen our recommended plan:</span><br/>
                        <span style="font-size: 24px;"><b>Safety Monitoring Center</b></span><br/>
                        <span style="font-size: 16px;">Get 24/7 emergency help from our Safety Monitoring Center.</span><br/>
                        
                    </li>
      
                    <li *ngIf="plan.type == 'automated'" class="list-group-item">
                        <span style="font-size: 16px;">You have chosen the plan:</span><br/>
                        <span style="font-size: 24px;"><b>Automated Monitoring</b></span><br/>
                        <span style="font-size: 16px;">Know when your people need help with instant automated alerts.</span><br/>
                   </li>
      
      
                    <li *ngIf="plan.type == 'essentials'" class="list-group-item">
                        <span style="font-size: 16px;">You have chosen the plan:</span><br/>
                        <span style="font-size: 24px;"><b>Essential Protection</b></span><br/>
                        <span style="font-size: 16px;">Monitor and locate your at-risk workers in-house.</span><br/>
                    </li>

                    <li *ngIf="plan.business" class="list-group-item">
                        <span style="font-size: 16px;">You also have the Additonal Plan</span><br/>
                        <span style="font-size: 20px;"><b>Business plus add ons</b></span><br/>
                    </li>
      
                      <li class="list-group-item">
                        <span style="font-size:28px;">That's only <b>{{plan.currency}}{{plan.per_worker_total}}</b><span style="font-size:18px;">/worker/month</span></span><br/>
                        <span style="font-size:18px;"><b>{{plan.currency}}{{plan.total}}/month in total</b></span><br/><br/>
                        <!-- <span style="font-size: 14px;" *ngIf="plan.volume_discount > 0">Your quote includes a {{plan.volume_discount}}% volume discount. <br/></span>
                        <span style="font-size: 14px;" *ngIf="plan.contract_discount > 0">Your quote includes a {{plan.contract_discount}}% discount for a {{plan.contract_length}} month contract. <br/></span> -->
                      </li>
                </ul>
                <div class="text-center">
                    <button type="submit" class="btn btn-success  btn-lg text-white" (click)="savePlan()" [disabled]="sending || showSalesContact" *ngIf="updated_plan && !showSalesContact">        
                        <span *ngIf="!loading"><i class="fa fa-check"></i> Save this New Plan</span>
                        <span *ngIf="loading">Please Wait <i class="fa fa-spinner fa-spin" aria-hidden="true"></i></span>    
                    </button> 
                </div>

                <br/>
                <div class="text-center">
                    <a class="btn btn-link" href="https://www.okaloneworker.com/pricing/our-plans/" role="button" target="_new">What's Included with your Plan</a>
                </div>
                }
            </div>
    </div>
    </ng-container>
</ng-container>